//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The seat cart item model
* 
* @param amount The price in cents
* @param label The label of the item
* @param ticketType The ticket type
*/
@Serializable

data class FloorPlanCartItem (


      /* The price in cents */
    @SerialName(value = "amount") @Required val amount: kotlin.Int,


      /* The label of the item */
    @SerialName(value = "label") @Required val label: kotlin.String,


      /* The ticket type */
    @SerialName(value = "ticketType") @Required val ticketType: kotlin.Int


) {




  }

